import type { CancelableRequestProducer } from '../common/types'
import { ideasbankApiClient } from '../index'

interface LikeIdeaApiResponse {
  liked: boolean
  likesCount: number
}

export interface LikeIdeaResponse extends LikeIdeaApiResponse {
  ideaId: string
}

export interface LikeIdeaPayload {
  ideaId: string
}

export const likeIdea = (payload: LikeIdeaPayload): CancelableRequestProducer<LikeIdeaResponse> => {
  const { ideaId } = payload

  const producer = ideasbankApiClient.post<LikeIdeaApiResponse>(`/ideas/${ideaId}/like`)

  return async (signal?: AbortSignal) => {
    const activeSignal = signal ?? new AbortController().signal
    const response = await producer(activeSignal)
    return {
      ...response,
      data: {
        ...response.data,
        ideaId,
      },
    }
  }
}

export const unlikeIdea = (payload: LikeIdeaPayload): CancelableRequestProducer<LikeIdeaResponse> => {
  const { ideaId } = payload

  const producer = ideasbankApiClient.delete<LikeIdeaApiResponse>(`/ideas/${ideaId}/like`)

  return async (signal?: AbortSignal) => {
    const activeSignal = signal ?? new AbortController().signal
    const response = await producer(activeSignal)
    return {
      ...response,
      data: {
        ...response.data,
        ideaId,
      },
    }
  }
}
